import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
import { Link } from "react-router-dom";
import useResponsive from "../../../hooks/useResponsive";
import { WorkshopParticipantDto } from "../../../types/workshopTypes";
import { MembersFieldDto } from "../../../types/membersTypes";

interface WorkshopParticipantsProps {
  participants: WorkshopParticipantDto[];
  removeParticipant: (participant: MembersFieldDto) => void;
  hasPermissions: boolean | undefined;
  status: "Anmeldung" | "Anmeldung abgeschlossen" | "Feedback" | "Abgeschlossen" | null;
}

/**
 * Displays the participants of an event
 * displays a remove button if the user is logged in and has permissions
 * @param participants - the participants of the event
 * @param removeParticipant - function to remove a participant from the event
 * @returns - the participants component
 */
const WorkshopParticipants: React.FunctionComponent<WorkshopParticipantsProps> = ({
  participants,
  removeParticipant,
  hasPermissions,
  status,
}: WorkshopParticipantsProps) => {
  const isMobile = useResponsive("down", "md");

  // function to handle the remove participant button
  const handleRemoveParticipant = (participant: MembersFieldDto) => {
    removeParticipant({
      memberId: participant.memberId,
      firstname: participant.firstname,
      lastname: participant.lastname,
    });
  };

  return (
    <Grid container columns={{ xs: 2, sm: 5, xl: 6 }}>
      {participants.map((item, index) => (
        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            direction: "row",
            alignItems: "center",
            position: "relative",
            "&:hover button": { opacity: 1 },
          }}
          key={index}
        >
          <Link to={`/gesamtuebersicht/${item.memberId}`} style={{ textDecoration: "none", color: "inherit" }}>
            <Typography key={index} variant="subtitle1" fontSize={14}>
              {item.firstName} {item.lastName}
            </Typography>
          </Link>
          {hasPermissions && status === "Anmeldung" && (
            <IconButton
              sx={{
                width: 20,
                height: 20,
                opacity: isMobile ? 1 : 0,
                "&:hover": { opacity: 1 },
              }}
              onClick={() => {
                handleRemoveParticipant({
                  memberId: item.memberId,
                  firstname: item.firstName,
                  lastname: item.lastName,
                });
              }}
            >
              <RemoveCircle sx={{ fontSize: 15, "&:hover": { color: "#d32f2f" } }} />
            </IconButton>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default WorkshopParticipants;
